module.exports = __webpack_public_path__ + "static/media/galerija_2019 (25).1f039463.jpg";